import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import {coerceToPrimitive, formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export default {
  name: 'MID',
  category: FunctionCategory.TEXT,
  shortDescription: 'A segment of a string.',
  description: 'Returns a segment of a string.',
  params: [
    {
      name: 'text',
      type: ArgType.any,
      description: 'The string to extract a segment from.',
    },
    {
      name: 'starting_at',
      type: ArgType.number, // 1-indexed, like Excel
      description:
        'The index from the left of string from which to begin extracting. The first character in string has the index 1.',
    },
    {
      name: 'extract_length',
      type: ArgType.number,
      description: 'The length of the segment to extract.',
    },
  ],

  processArgValues(arg1: TypedValue, arg2: TypedValue, arg3: TypedValue): [string, number, number] {
    return [
      formatTypedValue(arg1, {}, ''),
      coerceToPrimitive(arg2, {shouldCoerceStringToNumber: true}) as number,
      coerceToPrimitive(arg3, {shouldCoerceStringToNumber: true}) as number,
    ];
  },
  eval: (text: string, startNum: number, numChars: number): string => {
    // Given the possibility of floating-point imprecision in JavaScript, we'd have to round both up and down
    // to be safe. This would be inconsistent with Excel, which always rounds down, so we require integer
    // indices to avoid the ambiguity.
    if (!Number.isInteger(startNum)) {
      throw new util.ValueError('MID starting point must be an integer');
    }
    if (!Number.isInteger(numChars)) {
      throw new util.ValueError('MID number of characters must be an integer');
    }

    // Logic and errors should match the Excel function:
    // https://support.office.com/en-us/article/mid-midb-functions-d5f9e25c-d7d6-472e-b568-4ecb12433028
    if (startNum < 1) {
      throw new util.ValueError('MID starting point must be 1 or greater');
    }
    if (numChars < 0) {
      throw new util.ValueError('MID number of characters cannot be negative');
    }
    return text.slice(startNum - 1, startNum - 1 + numChars);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
